import React from 'react';
import AppLayout from '../Layout/AppLayout';
import MyDealListingsSection from './MyDealListingsSection';

// Seller-focused Deal Room hub. Buyer marketplace browse intentionally
// deferred — pending Polymet design (D13: Buyer Marketplace). The
// `DealListingCard`, filter components, `DealRoomEmptyState`, and the
// `search_deal_listings` GraphQL query remain in the codebase and will
// be wired up by the buyer-marketplace follow-up ticket once the
// prototype lands.
export default function DealRoomMarketplacePage({
  myListings = [],
  myListingsLoading = false,
  marketplaceTagline = '',
  persona = 'SELLER',
  userName = '',
  userInitials = '',
  planProgress = { completed: 0, total: 5, percentage: 0 },
  actionPlanBadge = 0,
  onCreateListing,
}) {
  const layoutProps = { persona, userName, userInitials, planProgress, actionPlanBadge };
  const hasListings = myListings.length > 0;

  return (
    <AppLayout {...layoutProps}>
      <div className="max-w-[1200px] mx-auto px-6 py-12">
        <header className="mb-10">
          <h1 className="font-serif text-[42px] font-light text-foreground tracking-[-0.02em] mb-2">
            Deal Room
          </h1>
          <p className="text-sm text-muted-foreground max-w-2xl">
            {marketplaceTagline ||
              'Manage your business listings. Confidential until you approve an NDA.'}
          </p>
          <div className="mt-6">
            <button
              type="button"
              onClick={onCreateListing}
              className="bg-foreground text-background rounded-full px-5 py-[9px] text-sm hover:bg-foreground/90 transition-colors"
            >
              {hasListings ? 'Add another listing' : 'List your business'}
            </button>
          </div>
        </header>

        {hasListings || myListingsLoading ? (
          <MyDealListingsSection listings={myListings} loading={myListingsLoading} />
        ) : (
          <SellerEmptyState onCreateListing={onCreateListing} />
        )}

        <BuyerMarketplaceComingSoon />
      </div>
    </AppLayout>
  );
}

function SellerEmptyState({ onCreateListing }) {
  return (
    <section className="bg-card border border-border rounded-[16px] p-12 text-center mb-8">
      <h2 className="text-[20px] font-semibold text-foreground mb-2">
        You haven't listed anything yet
      </h2>
      <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto">
        List your business confidentially. Your name and identity stay hidden until you approve an NDA with a qualified buyer.
      </p>
      <button
        type="button"
        onClick={onCreateListing}
        className="bg-foreground text-background rounded-full px-5 py-[9px] text-sm hover:bg-foreground/90 transition-colors"
      >
        Start a listing
      </button>
    </section>
  );
}

function BuyerMarketplaceComingSoon() {
  return (
    <aside className="border-t border-border pt-6 mt-12">
      <p className="font-mono text-[10px] uppercase text-muted-foreground/60 tracking-wide">
        Looking to buy? Buyer marketplace launches in a future sprint.
      </p>
    </aside>
  );
}
